module.exports = __webpack_public_path__ + "static/media/02_1.5799433d.png";